import { color, fontSize, fontWeight, themeGet } from 'styled-system'

export const getProp = themeGet

export const themeColorProp = color
export const themeFontSizeProp = fontSize
export const themeFontWeightProp = fontWeight
